import { useEffect, useState } from "react";
import CustomText, { C1Text, C2Text } from "../../../common/components/text/CustomText";
import { Column, Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import StoreThumbnail from "../../../common/components/image/StoreThumbnail";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";
import DashboardService from "../../../service/DashboardService";
import { format } from "date-fns";

export function DashboardRankCard() {
    const service = new DashboardService();
    const [topThree, setTopThree] = useState([]);

    const fetchTopThreeSales = () => {
        const today = format(new Date(), "yyyy-MM-dd");
        service
            .getTopThreeSales({ today })
            .then((result) => {
                setTopThree(Array.isArray(result) ? result : []);
            })
            .catch((error) => {
                console.error("Error fetching top three sales:", error);
            });
    };

    useEffect(() => {
        fetchTopThreeSales();
    }, []);

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"100%"}
            backgroundColor={"transparent"}
            justifyContent={"flex-start"}
            alignItem={"flex-start"}
            padding={"20px"}
        >
            <Column width={"100%"} justifyContent={"flex-start"} alignItem={"flex-start"}>
                <C1Text>{Translate("dashboard.topNumberSalesShops", ["3"])}</C1Text>
                <SizedBox height={"20px"} />
                {topThree.map((shop, index) => (
                    <div key={index} style={{ width: "100%" }}>
                        <Row justifyContent={"space-between"} width={"100%"} padding={"10px"}>
                            <Row>
                                <C1Text>{shop.ranking}</C1Text>
                                <SizedBox width={"16px"} />
                                <StoreThumbnail src={shop.imageUrl} />
                                <SizedBox width={"12px"} />
                                <Column justifyContent={"flex-start"} alignItem={"flex-start"}>
                                    <C2Text>{shop.storeName}</C2Text>
                                </Column>
                            </Row>
                            <CustomText fontSize={"18px"} fontWeight={"600"}>
                                {/* 실제 응답 필드는 todayRevenue (명세 필드표는 monthRevenue 로 표기) */}
                                ฿{(Number(shop.todayRevenue ?? shop.monthRevenue) || 0).toLocaleString()}
                            </CustomText>
                        </Row>
                        {index < topThree.length - 1 && (
                            <>
                                <SizedBox height={"20px"} />
                                <Divider />
                                <SizedBox height={"20px"} />
                            </>
                        )}
                    </div>
                ))}
            </Column>
        </SizedBox>
    );
}
